import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faWhatsapp } from '@fortawesome/fontawesome-free-brands';
import { faEnvelope, faUser } from '@fortawesome/fontawesome-free-solid';
import aashath from '../images/aashath.jpg'

export default function UserCard({img, name, github, linkedIn, gmail, portfolio, phone}) {
    
    return (
        <>
            <div className="member-card">
                <div className="member-image">
                    {img ? <img src={img} alt={aashath} /> : 'Image If Provided'}
                </div>
                <div className="member-details">
                    <p className='member-name'>{name}</p>
                    {phone && <a href={`https://api.whatsapp.com/send?phone=${phone}`} className='phone-number'><FontAwesomeIcon icon={faWhatsapp} className='whatsapp-icon' /> +91 {phone}</a>}
                    <p className="member-links">
                        {github && <a href={github}><FontAwesomeIcon icon={faGithub} /></a>}
                        {linkedIn && <a href={linkedIn}><FontAwesomeIcon icon={faLinkedin} /></a>}
                        {gmail && <a href={gmail}><FontAwesomeIcon icon={faEnvelope} /></a>}
                        {portfolio && <a href={portfolio}><FontAwesomeIcon icon={faUser} /></a>}
                    </p>
                </div>
            </div>
        </>
    )
}